const tbobooking = (
	location,
	response,
	invoice,
	dispatch,
	agentInfo,
	fareQuoteEtrav,
	payment,
	FlightBookEtravDispatch,
	history,
	FlightTicketLCCDispatch,
	FlightBookDispatch,
	agentlogin,
	BookingFormData,
	baggageInfo,
	mealInfo
) => {
	let formDataLCC = {
		TraceId: location.state.IDTBO,
		ResultIndex: location.state.OneflightData.ResultIndex,
		orderId: location.state.orderID,
		paymentId: response === 'success' ? invoice : response.razorpay_payment_id,
		Passengers: BookingFormData.map((item) => {
			return {
				Title: item.title,
				FirstName: item.firstname,
				LastName: item.lastname,
				PaxType: item.PaxType,
				DateOfBirth: item.dob?item.dob:'1998-03-09',
				Gender: 1,
				PassportNo:item.passportnumber?item.passportnumber:'',
				PassportExpiry: item.expiry?item.expiry:'',
				AddressLine1: 'demoaddress',
				AddressLine2: '',
				Fare: {
					Currency: location.state.OneflightData
						? location.state.OneflightData.Fare.Currency
						: '',
					BaseFare: location.state.OneflightData
						? location.state.OneflightData.Fare.OfferedFare
						: '',
					Tax: location.state.OneflightData
						? location.state.OneflightData.Fare.Tax
						: '',
					YQTax: location.state.OneflightData
						? location.state.OneflightData.Fare.YQTax
						: '',
					AdditionalTxnFeePub: location.state.OneflightData
						? location.state.OneflightData.Fare.AdditionalTxnFeePub
						: '',
					AdditionalTxnFeeOfrd: location.state.OneflightData
						? location.state.OneflightData.Fare.AdditionalTxnFeeOfrd
						: '',
					OtherCharges: location.state.OneflightData
						? location.state.OneflightData.Fare.OtherCharges
						: '',
					Discount: location.state.OneflightData
						? location.state.OneflightData.Fare.Discount
						: '',
					PublishedFare: location.state.OneflightData
						? location.state.OneflightData.Fare.PublishedFare
						: '',
					OfferedFare: location.state.OneflightData
						? location.state.OneflightData.Fare.OfferedFare
						: '',
					TdsOnCommission: location.state.OneflightData
						? location.state.OneflightData.Fare.TdsOnCommission
						: '',
					TdsOnPLB: location.state.OneflightData
						? location.state.OneflightData.Fare.TdsOnPLB
						: '',
					TdsOnIncentive: location.state.OneflightData
						? location.state.OneflightData.Fare.TdsOnIncentive
						: '',
					ServiceFee: location.state.OneflightData
						? location.state.OneflightData.Fare.ServiceFee
						: '',
				},
				City: 'demo',
				CountryCode: 'IN',
				CellCountryCode: '+91',
				ContactNo: location.state.formData ? location.state.formData.phone : '',
				Nationality: 'IN',
				Email: location.state.formData ? location.state.formData.email : '',
				IsLeadPax: true,
				FFAirlineCode: null,
				FFNumber: '',
				GSTCompanyAddress: '',
				GSTCompanyContactNumber: '',
				GSTCompanyName: '',
				GSTNumber: '',
				GSTCompanyEmail: '',
				Baggage: item.baggage?[item.baggage]:[],
		MealDynamic: item.meal?[item.meal]:[],
			};
			
		}),
		
		// SeatDynamic: [],
	};
	console.log('FormData', formDataLCC);
	dispatch(FlightTicketLCCDispatch(formDataLCC, history, location.state,agentlogin));
	
};

export default tbobooking;
